export interface PhoneValue {
  dialCode: string;
  // ISO 3166-1 alpha-2 code — carried alongside the dial code so we can
  // disambiguate countries that share the same dial code (e.g. US vs CA on +1,
  // or the various NANP entries on +1-*).
  isoCode: string;
  number: string;
}

export const DEFAULT_PHONE_VALUE: PhoneValue = { dialCode: '+91', isoCode: 'IN', number: '' };

export function composePhoneNumber(value: PhoneValue): string {
  const num = value.number.trim();
  if (!num) return '';
  return `${value.dialCode}-${num}`;
}
